import { Divider } from "antd";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  analytics_cards,
  analytics_cards_all,
  analytics_cards_export,
} from "../../actions/cards/cards";
import BarGraph from "./BarGraph";
import ReportTable from "./ReportTable";
import MISTrips from "../Common/PDF/MISPDF/MISTrips";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

const Trips = ({ showGraph, apiFilters, setFilterObj, setpdfURL, ...props }) => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.analytics.analytics_cards);
  const pdfData = useSelector((state) => state.analytics.analytics_cards_all);

  useEffect(() => {
    dispatch(analytics_cards({ type: "trips" }));
    dispatch(analytics_cards_all({ type: "trips", csv: true }));
    dispatch(analytics_cards_export({ pdf: true, csv: true, type: "trips" }));
    setFilterObj({});
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    props.pdfURL(downloadPdf)
  }, [pdfData])

  const downloadPdf = async () => {
    const blob = await pdf((
      <MISTrips data={pdfData?.data?.response?.trip || []} />
    )).toBlob();
    saveAs(blob, "MISTrips.pdf");
  }

  const getObjs = () => {
    if (cards?.data?.response?.report?.length > 0) {
      return cards?.data?.response?.report?.[0]?.custom_fields?.map(ele => ({
        title: ele.key?.replace("_", " "),
        dataIndex: "custom_fields",
        key: "custom_fields",
        render: (text, data) => <div>{data?.custom_fields?.find(itm => itm.key === ele.key)?.value}</div>,
      }))
    }

    return []
  }

  const handlePaginationCall = (vals) => {
        vals.type = "trips";
        
        const finalVals = {};
        for (const key in vals) {
          if (Array.isArray(vals[key])) {
            finalVals[key] = vals[key].join(',');
          } else {
            finalVals[key] = vals[key];
          }
        }
        
        dispatch(analytics_cards(finalVals));
        dispatch(analytics_cards_export({ pdf: true, csv: true, ...finalVals }));
      }


  const columns = useMemo(() => [
    {
      title: "Trip ID",
      dataIndex: "trip_number",
      key: "trip_number",
      render: (text, data) => {
        return <div className={`render_common_style status_${data?.Status}`}>{text}</div>;
      },
    },
    {
      title: "Trip Name",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "employee_name",
    },
    {
      title: "Purpose",
      dataIndex: "business_purpose",
      key: "business_purpose",
    },
    {
      title: "Submitted On",
      dataIndex: "submitted_on",
      key: "submitted_on",
    },
    ...getObjs(),
    {
      title: "Cost Center",
      dataIndex: "cost_center",
      key: "cost_center",
    },
    {
      title: "Project",
      dataIndex: "project",
      key: "project",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <div className={`status status_${text}`}>{text}</div>,
    },
    // eslint-disable-next-line
  ], [cards]);

  return (
    <>

      <div className="reports">
        {showGraph && (
          <>
            <Divider />
            <div
              className="mt1"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <BarGraph
                width={1000}
                height={350}
                id={"lineAreaGraph"}
                data={[
                  { day: "Jan", txnValue: 39 },
                  { day: "Feb", txnValue: 49 },
                  { day: "Mar", txnValue: 69 },
                  { day: "Apr", txnValue: 59 },
                ]}
                barColor={"#F48C32"}
              />
            </div>
          </>
        )}
        <Divider />
      </div>
      <ReportTable
        columns={columns}
        // scroll={{ x: 1400 }}
        data={cards?.data?.response?.trip || []}
        total_records={cards?.data?.total_records}
        paginationCall={handlePaginationCall}
        payload={{ ...props.filterObj, ...apiFilters }}
      />
    </>
  );
};

export default Trips;
